import type { JSONContent } from "@tiptap/core";
import { tiptapDocToBlocks } from "@/lib/tiptap/document-serializer";

type Fetcher = (url: string, init?: RequestInit) => Promise<Response>;

/** One canvas node as the block the server stores, or null if it maps to none. */
export function blockFromNode(node: JSONContent): { type: string; content: Record<string, unknown> } | null {
  const [block] = tiptapDocToBlocks({ type: "doc", content: [node] });
  return block ? { type: block.type, content: block.content as Record<string, unknown> } : null;
}

/**
 * The LaTeX Lilia compiles for one block — what "Copy LaTeX" puts on the
 * clipboard (copy-out rule 1: text/plain is the LaTeX Lilia compiles). The
 * server renders it, so the copy matches the export exactly.
 */
export async function blockLatex(fetcher: Fetcher, node: JSONContent): Promise<string> {
  const block = blockFromNode(node);
  if (!block) throw new Error("This block has no LaTeX.");
  const res = await fetcher("/api/convert/block-to-latex", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(block),
  });
  if (!res.ok) throw new Error("Couldn't render this block's LaTeX.");
  const latex = (((await res.json()) as { latex?: string }).latex ?? "").trim();
  if (!latex) throw new Error("This block has no LaTeX.");
  return latex;
}
